const SignInCallBack = () => import('../components/odic/sign-in-callback.vue');
const routes = [
    { path: '/odic/sign-in-callback', component: SignInCallBack },
    {
        path: '/:lang',
        component: { render: h => h('router-view') },
        children: [
            {
                path: '',
                component: () => import('../layouts/MainLayout.vue'),
                children: [
                    {
                        path: '', component: () => import('../pages/index.vue'),
                    },
                    {
                        path: 'signin', component: () => import('../pages/signin.vue'),
                    },
                    {
                        path: 'signup', component: () => import('../pages/signup.vue'),
                    },
                    {
                        path: 'terms', component: () => import('../pages/term.vue'),
                    },
                    {
                        path: 'trips', component: () => import('../pages/trips.vue'),
                    },
                    {
                        path: 'checkout', component: () => import('../pages/checkout.vue'),
                    },
                    {
                        path: 'landing', component: () => import('../pages/landing.vue'),
                    },
                    {
                        path: 'success', component: () => import('../pages/success.vue'),
                    },
                    // {
                    //     path: 'error:code', component: () => import('../pages/error.vue'),
                    // },
                    {
                        path: 'cancellation', component: () => import('../pages/cancellation.vue'),
                    },
                    {
                        path: 'change', component: () => import('../pages/change.vue'),
                    },
                    {
                        path: 'change-passengers', component: () => import('../pages/change-passengers.vue'),
                    },
                    {
                        path: 'error',
                        component: { render: h => h('router-view') },
                        children: [
                            { path: ':code', component: () => import('../pages/error.vue') },
                        ]
                    },
                    {
                        path: 'account',
                        meta: { requiresAuth: true },
                        component: { render: h => h('router-view') },
                        children: [
                            { path: '', component: () => import('../pages/account.index.vue') },
                            {
                                path: 'orders',
                                component: { render: h => h('router-view') },
                                children: [
                                    { path: '', component: () => import('../pages/account.orders.vue') },
                                    { path: ':id', component: () => import('../pages/account.order.vue') },
                                ]
                            },
                            { path: 'delete-account', component: () => import('../pages/account.delete-account.vue') },
                            { path: 'change-password', component: () => import('../pages/account.change-password.vue') },
                            { path: 'profile', component: () => import('../pages/account.profile.vue') },
                        ]
                    },
                    { path: 'account-delete-success', component: () => import('../pages/account.delete-success.vue') },
                    { path: 'forget-password', component: () => import('../pages/forget-password.vue') },
                    { path: 'reset-password', component: () => import('../pages/reset-password.vue') },
                    { path: 'term-online-sale', component: () => import('../pages/term-online-sale.vue') },
                    { path: 'term-reservation', component: () => import('../pages/term-reservation.vue') },
                    { path: 'term-free-ferry', component: () => import('../pages/term-free-ferry.vue') },
                    { path: 'term-auto-pass', component: () => import('../pages/term-auto-pass.vue') },
                ]
            },
        ]
    },
    {
        path: '*',
        component: () => import('../pages/error-404.vue')
    }
];
export default routes















